/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, FC, useRef } from 'react';
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import moment, { Moment } from 'moment';
import { getEvents } from 'actions/events';
import { IEvents } from 'types';
import { IRootState } from 'store';
import Title from 'components/common/Title';
import TimeLine from 'components/common/calendar/timeLine';
import CalendarHeader from 'components/common/calendar/calendarHeader';
import styles from 'components/common/calendar/index.module.scss';
import Scrollbars from 'react-custom-scrollbars';
import MobileService from 'services/mobile';
import Cells from './cells';
import './styles.scss';

const mapStateToProps = (state: IRootState) => ({
  eventsData: state.events,
  activeScholarId: state.users.userData?.activeScholarId,
});

type ICalendar = ReturnType<typeof mapStateToProps>;

const Calendar: FC<ICalendar | null> = ({ eventsData, activeScholarId }) => {
  const [currentMoment] = useState(moment());
  const [startDay, setStartDay] = useState(
    currentMoment.clone().startOf('year').startOf('week')
  );
  const [lastDay, setLastDay] = useState(
    currentMoment.clone().endOf('year').endOf('week')
  );
  const [daysToShow, setDaysToShow] = useState<number>(1);
  const [week, setWeeks] = useState(0);
  const [days, setDays] = useState<Moment[][]>([]);
  const [timeLine, setTimeLine] = useState<string[]>([]);
  const [events, setEvents] = useState<IEvents[] | []>(eventsData.eventsList);
  const [isWeekly, setIsWeekly] = useState(false);
  const [tableHeight, sedTableHeight] = useState('100%');
  const scroll = useRef<Scrollbars>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (activeScholarId && !_.isEmpty(days)) {
      if (days[week]) {
        const startDate = moment(days[week][0]).format();
        const endDate = moment(startDate).clone().add(6, 'days').format();
        dispatch(getEvents(activeScholarId, startDate, endDate));
      }
      setEvents(eventsData.eventsList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [week, days]);

  useEffect(() => {
    setEvents(eventsData.eventsList);
  }, [eventsData.eventsList, week]);

  const searcIndex = (inputArray: Moment[][], searchValue: string) => {
    const arrayString: string[][] =
      (!_.isEmpty(inputArray) &&
        inputArray.map((w: Moment[]) => {
          const toString = w.map((day: Moment) => {
            return moment(day).format('YYYY-MM-DD');
          });
          return toString;
        })) ||
      [];

    for (let i = 0, l = inputArray.length; i < l; i += 1) {
      const j = arrayString[i].indexOf(searchValue);
      if (j >= 0) {
        return [i, j];
      }
    }
    return null;
  };

  useEffect(() => {
    const day = startDay.clone().subtract(1, 'day');
    const calendar = [];

    while (day.isBefore(lastDay, 'day')) {
      calendar.push(
        Array(daysToShow)
          .fill(0)
          .map(() => day.add(1, 'day').clone())
      );
    }
    const calendarString: any =
      (!_.isEmpty(calendar) &&
        calendar.map((w: Moment[]) => {
          const daysToString = w.map((d: Moment) => {
            return moment(d).format('YYYY-MM-DD');
          });
          return daysToString || '';
        })) ||
      [];
    const currentWeek = searcIndex(
      calendarString,
      moment().format('YYYY-MM-DD')
    );
    if (currentWeek) {
      setWeeks(currentWeek[0]);
    }
    setDays(calendar);
  }, [daysToShow, currentMoment, lastDay, startDay]);

  useEffect(() => {
    const top = ((scroll.current?.getScrollHeight() || 0) * 7) / 24;
    scroll.current?.scrollTop(top);
  }, [days, week]);

  const handleChangeWeek = (value: number) => {
    setWeeks(value);
  };

  const tableWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (MobileService.isMobile) {
      const height = tableWrapperRef.current?.getBoundingClientRect()?.height;

      if (height) {
        sedTableHeight(`${height - 100}px`);
      }
    }
  }, [tableWrapperRef]);

  return (
    <div className={styles.calendar}>
      <Title
        className={`calendarTitle ${MobileService.isMobile ? 'tablet' : ''}`}
      >
        The What’s Next Room
      </Title>
      {!_.isEmpty(days) && (
        <CalendarHeader
          week={week}
          isWeekly={isWeekly}
          setIsWeekly={setIsWeekly}
          handleChangeWeek={handleChangeWeek}
          setDaysToShow={setDaysToShow}
          currentMoment={currentMoment}
          searcIndex={searcIndex}
          date={days[week]}
          days={days}
          lastDay={lastDay}
          startDay={startDay}
          setLastDay={setLastDay}
          setStartDay={setStartDay}
        />
      )}
      <div className={styles.scrollbarWrapper} ref={tableWrapperRef}>
        <div className={styles.daysHeader}>
          {!_.isEmpty(days) &&
            !_.isEmpty(days[week]) &&
            days[week].map((day: Moment) => (
              <span key={day.toString()}>{`${moment(day).format(
                'dddd, D'
              )}`}</span>
            ))}
        </div>
        <Scrollbars ref={scroll} autoHide style={{ height: tableHeight }}>
          <div className={styles.calendarContent}>
            <div className={styles.calendarBlock}>
              <TimeLine
                cellSize="L"
                onChange={setTimeLine}
                timeLine={timeLine}
              />
              <Cells
                days={days}
                weekCount={week}
                daysToShow={daysToShow}
                events={events}
                timeLine={timeLine}
              />
            </div>
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(Calendar);
